/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
// material
import { Button } from '@insticator/insticator-ui'; // iui-material
// pages
import PreviewPage from 'pages/dashboard/embeds/management/preview/preview_container';
// utils
import { isContentValid, isAddOnValid } from 'utils/embedcontentvalidation';



/* ========== ~~~~~~~~~~ CTA : PREVIEW ~~~~~~~~~~ ========== */
const PreviewCTA = (props) => {
	function handleClick(e) {
		e.preventDefault();
        if(isContentValid(props.selectedContent) && isAddOnValid(props.editingAddOn, handleCurrentAddOnData(props.editingAddOn))) {
            props.displayModal(true, <PreviewPage />);
            if(!!props.editingAddOn) props.invalidateActiveAddOn(props.editingAddOn);
        } else {
            if(!!props.selectedContent) props.invalidateSelectedContent();
            if(!!props.editingAddOn) props.invalidateActiveAddOn(props.editingAddOn);
            props.sendMessage('There are required fields you must fill out before continuing.');
        }
	}

    const handleCurrentAddOnData = type => {
        switch (type) {
            case 'EMAIL_COLLECTION':
            default:
                return props.userDataCollection;
        }
    };

    return(
        <Button
            type={`custom`}
            handleClick={handleClick}
            variant={`primary`}
            name={`preview`}
            text={`Preview`}
        />
    );
};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default PreviewCTA;
